<template lang="pug">
  .county-summary
    p(
      style="text-align: justify"
    ) Select a county and click the download button to download the selected county's WUI Risk Infosheet.
    v-combobox(
      v-model="county"
      :items="items"
      item-text="name"
      label="Select a county"
    )
    v-btn(
      light
      color="secondary"
      @click="downloadPDF"
    )
      v-icon(left) insert_drive_file
      | Download Report
</template>

<script>

export default {
  data () {
    return {
      county: null,
      items: [
        { name: 'Adams County', file: 'AdamsCountySummary.pdf'},
        { name: 'Alamosa County', file: 'AlamosaCountySummary.pdf'},
        { name: 'Arapahoe County', file: 'ArapahoeCountySummary.pdf'},
        { name: 'Archuleta County', file: 'ArchuletaCountySummary.pdf'},
        { name: 'Baca County', file: 'BacaCountySummary.pdf'},
        { name: 'Bent County', file: 'BentCountySummary.pdf'},
        { name: 'Boulder County', file: 'BoulderCountySummary.pdf'},
        { name: 'Broomfield County', file: 'BroomfieldCountySummary.pdf'},
        { name: 'Chaffee County', file: 'ChaffeeCountySummary.pdf'},
        { name: 'Cheyenne County', file: 'CheyenneCountySummary.pdf'},
        { name: 'ClearCreek County', file: 'ClearCreekCountySummary.pdf'},
        { name: 'Conejos County', file: 'ConejosCountySummary.pdf'},
        { name: 'Costilla County', file: 'CostillaCountySummary.pdf'},
        { name: 'Crowley County', file: 'CrowleyCountySummary.pdf'},
        { name: 'Custer County', file: 'CusterCountySummary.pdf'},
        { name: 'Delta County', file: 'DeltaCountySummary.pdf'},
        { name: 'Denver County', file: 'DenverCountySummary.pdf'},
        { name: 'Dolores County', file: 'DoloresCountySummary.pdf'},
        { name: 'Douglas County', file: 'DouglasCountySummary.pdf'},
        { name: 'Eagle County', file: 'EagleCountySummary.pdf'},
        { name: 'Elbert County', file: 'ElbertCountySummary.pdf'},
        { name: 'ElPaso County', file: 'ElPasoCountySummary.pdf'},
        { name: 'Fremont County', file: 'FremontCountySummary.pdf'},
        { name: 'Garfield County', file: 'GarfieldCountySummary.pdf'},
        { name: 'Gilpin County', file: 'GilpinCountySummary.pdf'},
        { name: 'Grand County', file: 'GrandCountySummary.pdf'},
        { name: 'Gunnison County', file: 'GunnisonCountySummary.pdf'},
        { name: 'Hinsdale County', file: 'HinsdaleCountySummary.pdf'},
        { name: 'Huerfano County', file: 'HuerfanoCountySummary.pdf'},
        { name: 'Jackson County', file: 'JacksonCountySummary.pdf'},
        { name: 'Jefferson County', file: 'JeffersonCountySummary.pdf'},
        { name: 'Kiowa County', file: 'KiowaCountySummary.pdf'},
        { name: 'KitCarson County', file: 'KitCarsonCountySummary.pdf'},
        { name: 'Lake County', file: 'LakeCountySummary.pdf'},
        { name: 'LaPlata County', file: 'LaPlataCountySummary.pdf'},
        { name: 'Larimer County', file: 'LarimerCountySummary.pdf'},
        { name: 'LasAnimas County', file: 'LasAnimasCountySummary.pdf'},
        { name: 'Lincoln County', file: 'LincolnCountySummary.pdf'},
        { name: 'Logan County', file: 'LoganCountySummary.pdf'},
        { name: 'Mesa County', file: 'MesaCountySummary.pdf'},
        { name: 'Mineral County', file: 'MineralCountySummary.pdf'},
        { name: 'Moffat County', file: 'MoffatCountySummary.pdf'},
        { name: 'Montezuma County', file: 'MontezumaCountySummary.pdf'},
        { name: 'Montrose County', file: 'MontroseCountySummary.pdf'},
        { name: 'Morgan County', file: 'MorganCountySummary.pdf'},
        { name: 'Otero County', file: 'OteroCountySummary.pdf'},
        { name: 'Ouray County', file: 'OurayCountySummary.pdf'},
        { name: 'Park County', file: 'ParkCountySummary.pdf'},
        { name: 'Phillips County', file: 'PhillipsCountySummary.pdf'},
        { name: 'Pitkin County', file: 'PitkinCountySummary.pdf'},
        { name: 'Prowers County', file: 'ProwersCountySummary.pdf'},
        { name: 'Pueblo County', file: 'PuebloCountySummary.pdf'},
        { name: 'RioBlanco County', file: 'RioBlancoCountySummary.pdf'},
        { name: 'RioGrande County', file: 'RioGrandeCountySummary.pdf'},
        { name: 'Routt County', file: 'RouttCountySummary.pdf'},
        { name: 'Saguache County', file: 'SaguacheCountySummary.pdf'},
        { name: 'SanJuan County', file: 'SanJuanCountySummary.pdf'},
        { name: 'SanMiguel County', file: 'SanMiguelCountySummary.pdf'},
        { name: 'Sedgwick County', file: 'SedgwickCountySummary.pdf'},
        { name: 'Summit County', file: 'SummitCountySummary.pdf'},
        { name: 'Teller County', file: 'TellerCountySummary.pdf'},
        { name: 'Washington County', file: 'WashingtonCountySummary.pdf'},
        { name: 'Weld County', file: 'WeldCountySummary.pdf'},
        { name: 'Yuma County', file: 'YumaCountySummary.pdf'}
      ]
    }
  },
  methods: {
    downloadPDF () {
      window.open(`/api/docs/${this.county.file}`, '_blank')
    }
  }
}
</script>

<style lang="stylus" scoped>
  .county-summary
    padding 1em
    .v-btn.theme--light.secondary
      width 100%
      margin-left 0
      color black !important
</style>
